import { Box, Typography } from "@mui/material"
import { useContextState } from "../../../hooks/theme"
import { ItemMenu } from "../../baseMenu"
import { useStyles } from "./styles"
import { useTranslation } from "react-i18next"

export const useMenuList = (): ItemMenu[] => {
    const { state, colors } = useContextState()
    const { t } = useTranslation()
    const styles = useStyles(colors)

    return [
        {
            children: (
                <Box sx={styles.user}>
                    <Typography variant="subtitle" fontWeight='bold'>{state?.fullName}</Typography>

                    {!!state?.userType?.name && <Typography variant="footer">{state?.userType?.name}</Typography>}

                    {!!state?.roleName && <Typography variant="footer">{state?.roleName}</Typography>}

                    {!!state?.company?.name && <Typography variant="footer">{state?.company?.name}</Typography>}
                </Box>
            ),
            value: '1'
        },
        {
            value: '2',
            children: <Box sx={styles.container}><Typography textAlign={"end"} pl={2} pr={2} variant="footer">{t('general.closeSession')}</Typography></Box>
        }
    ]
}